// Languages
export const LANGUAGES = {
  EN: 'en',
  DK: 'dk',
  SE: 'se',
  DE: 'de',
  FI: 'fi',
  PL: 'pl',
  NO: 'no',
}
export const DEFAULT_LANGUAGE = LANGUAGES.EN
export const LANGUAGE_COOKIE_NAME = 'UP_LANG'
export const LANGUAGE_COOKIE_EXPIRY_SECONDS = 86400 * 7 // seconds in day * 7

// Doc Types
export const DOC_TYPES = {
  PAGE: 'page',
  BLOG_POST: 'blogPost',
  CASE_STUDY: 'caseStudy',
  GLOBAL_SETTINGS: 'globalSettings',
}

// Directories
export const DIRECTORY_NAMES = {
  BLOG_POSTS: 'news',
  CASE_STUDIES: 'case-study',
}

export const SANITY_EVERYTHING_TAG = 'everything'

// Slugs / Paths
export const FOUR_OH_FOUR_SLUG = '404'
export const HOME_SLUG = 'home'

export const TRANSITION_DURATION = 1

export const ALLOW_IS_IN_VIEW_DELAY_MS = 500

export const PRELOADER_COOKIE_NAME = 'VIEWED_PRELOADER_2.0'

export const PAGINATION_ITEMS_PER_PAGE = 6
